import React, { useEffect, useState } from 'react';
import { BoldButton } from '@bold/web-components-react';
import SegmentButton from 'components/website/SegmentButton';
import goToSupportURL from 'utils/whatsappFunction';

const ContactButton = ({ buttonId, link, buttonLabel }) => {
  const [button, setButton] = useState();

  const handleWebSupport = e => {
    e.preventDefault();

    const whatsAppOptions = {
      subject: 'support',
      from: 'contact_page',
      phone: 'support',
      text: 'Hola necesito ayuda con uno de sus productos, pueden darme mas información?',
    };

    goToSupportURL(whatsAppOptions);
  };

  const handleSalesSupport = e => {
    e.preventDefault();

    const whatsAppOptions = {
      subject: 'sales',
      from: 'contact_page',
      phone: 'default',
      text: '¡Hola! me interesa el datáfono Bold, ¿Pueden darme más información?',
    };

    goToSupportURL(whatsAppOptions);
  };

  useEffect(() => {
    const buttons = {
      sales: (
        <SegmentButton
          event="contactsales"
          obj={{
            page_section: 'contactanos',
            contact_channel: 'escribir',
          }}
        >
          <BoldButton onClick={handleSalesSupport}>Escribir a Ventas</BoldButton>
        </SegmentButton>
      ),
      support: (
        <SegmentButton
          event="contactsupport"
          obj={{
            page_section: 'contactanos',
            contact_channel: 'escribir',
          }}
        >
          <BoldButton onClick={handleWebSupport}>Escribir a Soporte</BoldButton>
        </SegmentButton>
      ),
      infosec: (
        <SegmentButton
          event="contactsupport"
          isLink
          isBlank
          url="https://docs.google.com/forms/d/e/1FAIpQLSfAeuVDyEQxDYzPvyPBfEmZfqNXhExfxAcGsqm9_Ib7q9JnrQ/viewform"
          obj={{
            page_section: 'contactanos',
            contact_channel: 'escribir_infosec',
          }}
        >
          <BoldButton>Escribir a InfoSec</BoldButton>
        </SegmentButton>
      ),
      link: (
        <SegmentButton
          event="contactsupport"
          isLink
          isBlank
          url={link}
          obj={{
            page_section: 'contactanos',
            contact_channel: 'llamar',
          }}
        >
          <BoldButton>{buttonLabel}</BoldButton>
        </SegmentButton>
      ),
    };

    setButton(buttons[buttonId]);
  }, [buttonId, link, buttonLabel]);

  return <div className="button-wrapper">{button}</div>;
};

export default ContactButton;
